import React, { useContext } from "react";
import "../styles/global.css";
import { LanguageContext } from "../utils/LanguageContext";
import Languages from "../components/NavBar/components/Languages";

const AuthLayout = ({ children }) => {
  const { changeLanguage } = useContext(LanguageContext);

  return (
    <div className="width-100 auth-container">
      <div className="auth-language-switcher">
        <Languages
          variant="inline"
          setIsBarOpen={() => {}}
          setOpenLanguages={() => {}}
          setLanguageGeneral={changeLanguage}
        />
      </div>
      <div className="flex-direction-row items-center justify-center auth-content">
        {children}
      </div>
    </div>
  );
};

export default AuthLayout;
